import React from 'react';
import { IconStar } from './Icons';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './FeaturedTestimonials.css';

const FeaturedTestimonials = () => {
  const { t } = useLanguage();
  const testimonials = [
    { id: 1, text: t.featuredTestimonials.testimonial1, name: "Patrick Hild", title: t.testimonials.role_geschaeftsfuehrer, company: "Lucky Treats", image: "/img/testimonials/Patrick Hild.jpeg", rating: 5, website: null },
    { id: 2, text: t.featuredTestimonials.testimonial2, name: "Christof Jugel", title: t.testimonials.role_gruender, company: "Nyfter", image: "/img/testimonials/Christof Jugel Nyfter.webp", rating: 5, website: "https://nyfter.com" },
    { id: 3, text: t.featuredTestimonials.testimonial3, name: "Andreas Oswald", title: t.testimonials.role_geschaeftsfuehrer, company: "Oswald Lederwaren", image: "/img/testimonials/oswald bild.jpeg", rating: 5, website: "https://oswald-lederwaren.de" },
    { id: 4, text: t.featuredTestimonials.testimonial4, name: "Stefan", title: t.testimonials.role_geschaeftsfuehrer, company: "Papierdrachen", image: "/img/papierdrache.jpeg", rating: 5, website: "https://papierdrachen.de" },
  ];

  const containerReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="featured-testimonials-fox">
      <div ref={containerReveal.ref} className={`featured-testimonials-fox__container reveal--fade ${containerReveal.isRevealed ? 'reveal--visible' : ''}`}>
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="featured-testimonials-fox__item reveal-child">
            <div className="featured-testimonials-fox__image-wrapper">
              <img src={testimonial.image} alt={testimonial.name} className="featured-testimonials-fox__image" width={80} height={80} loading="lazy" decoding="async" />
            </div>
            <div className="featured-testimonials-fox__content">
              <div className="featured-testimonials-fox__stars">
                {[...Array(testimonial.rating)].map((_, i) => (<IconStar key={i} size={16} filled={true} />))}
              </div>
              <p className="featured-testimonials-fox__text">"{testimonial.text}"</p>
              <div className="featured-testimonials-fox__author">
                <div className="featured-testimonials-fox__author-info">
                  <p className="featured-testimonials-fox__name">{testimonial.name}</p>
                  <p className="featured-testimonials-fox__role">{testimonial.title}, {testimonial.company}</p>
                  {testimonial.website && (
                    <a href={testimonial.website} target="_blank" rel="noopener noreferrer" className="featured-testimonials-fox__website-link">
                      {testimonial.website.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '')}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedTestimonials;
